export interface HotelNameParts {
  title: string;
  direction: string;
}

export function splitHotelName(name: string): HotelNameParts {
  const separatorIndex = name.lastIndexOf(',');

  if (separatorIndex === -1) {
    return { title: name, direction: '' };
  }

  return { title: name.slice(0, separatorIndex), direction: name.slice(separatorIndex + 1).trim() };
}
